module.exports = __webpack_public_path__ + "img/lata-lixo-excluir.0d96f71f.svg";